import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgentsComponent } from './agents.component';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    AgentsComponent
  ]
})
export class AgentsModule { }
